import { createStore } from 'vuex'
import VuexPersistence from 'vuex-persist'
const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})
const store = createStore({
  state() {
    return {
      loader:false
    }
  },
  plugins: [vuexLocal.plugin],
  mutations: {
    loader(state, loader){
      state.loader = loader;
    },
    reset(state) {
      state.loader = false
    }
  }
})

export { store }